// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".96e5d5b97a06e9ea9ce8cff6400e6a07f60dd159.chunk.js";
};